// object to store loaded and loading wasm modules
var installedWasmModules = {};

function promiseResolve() { return Promise.resolve(); }


var wasmImportObjects = {
	1527: function() {
		return {

		};
	},
};

var wasmModuleMap = {
	"914": [
		1527
	]
};

// object with all WebAssembly.instance exports
__webpack_require__.w = {};

// Fetch + compile chunk loading for webassembly
__webpack_require__.f.wasm = function(chunkId, promises) {

	var wasmModules = wasmModuleMap[chunkId] || [];

	wasmModules.forEach(function(wasmModuleId, idx) {
		var installedWasmModuleData = installedWasmModules[wasmModuleId];

		// a Promise means "currently loading" or "already loaded".
		if(installedWasmModuleData)
			promises.push(installedWasmModuleData);
		else {
			var importObject = wasmImportObjects[wasmModuleId]();
			var req = fetch(__webpack_require__.p + "" + {"914":{"1527":"ad13da76642d8099fe70"}}[chunkId][wasmModuleId] + ".module.wasm");
			var promise;
			if(importObject && typeof importObject.then === 'function' && typeof WebAssembly.compileStreaming === 'function') {
				promise = Promise.all([WebAssembly.compileStreaming(req), importObject]).then(function(items) {
					return WebAssembly.instantiate(items[0], items[1]);
				});
			} else if(typeof WebAssembly.instantiateStreaming === 'function') {
				promise = WebAssembly.instantiateStreaming(req, importObject);
			} else {
				var bytesPromise = req.then(function(x) { return x.arrayBuffer(); });
				promise = bytesPromise.then(function(bytes) {
					return WebAssembly.instantiate(bytes, importObject);
				});
			}
			promises.push(installedWasmModules[wasmModuleId] = promise.then(function(res) {
				return __webpack_require__.w[wasmModuleId] = (res.instance || res).exports;
			}));
		}
	});
};